import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const DividerStyled = styled.hr<T>`
  opacity: 0.5;
  border: 1px solid #ebebeb;
  border-radius: 3px;
`;
